import { Root } from "./Styles";

export default function KuvaButton({ value, onClick }) {
  return (
    <Root variant="contained" color="secondary" onClick={onClick}>
      {value}
    </Root>
  );
}
